import React, {useEffect} from 'react';
import { v4 as uuid } from 'uuid';
import {useDispatch} from "react-redux";
import {setBackground} from "../../../store/slices/productFinder";

const QuestionPage = (props) => {

    const {
        pageData,
        onOptionClick
    } = props;

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setBackground(pageData?.background || 'dots'));
    }, [pageData]);

    return (
        <div className="generic-wrapper" key={`question_${uuid()}`}>
            <Question
                onOptionClick={onOptionClick}
                question={pageData}
            />
        </div>
    )

}

const Question = (props) => {

    const {
        question,
        onOptionClick
    } = props;

    const onClick = (option) => {
        if(onOptionClick && typeof onOptionClick === 'function') {
            onOptionClick(option.next);
        }
    }

    return (
        <div className="product-finder-page product-finder-page__question">

            <h2
                className="h4 animate slide-in-bottom animation-delay-3"
            >
                { question.question }
            </h2>

            { (question.options && question.options.length) &&
                <Options
                    options={question.options}
                    onOptionClick={onClick}
                />
            }

        </div>
    )
}

const Options = (props) => {

    const {
        options,
        onOptionClick
    } = props;

    return (
        <div className="product-finder-question-options">
            { options.map((option, i) => {
                return (
                    <Option
                        key={`option_${uuid()}`}
                        option={option}
                        onClick={onOptionClick}
                        delay={i}
                    />
                )
            })}
        </div>
    )
}

const Option = (props) => {

    const {
        option,
        onClick,
        delay
    } = props;

    const delayCoef = 7;

    return (
        <div className={`product-finder-question-options-item animate slide-in-bottom animation-delay-${(delay+2) * delayCoef}`}>
            <button
                className="button button--style-1 text-default"
                onClick={ () => onClick(option) }
            >
                <span className={'button__label'}>
                    { option.label }
                </span>
            </button>
        </div>
    )
}

export default QuestionPage;
